'use client';

import { type FC } from 'react';
import { useCopiedDynamicYieldCookie } from './useCopiedDynamicYieldCookie';

export const DynamicYieldCookie: FC = () => {
  useCopiedDynamicYieldCookie();
  return null;
};
